import { render, staticRenderFns } from "./ViewSupplierModelList.vue?vue&type=template&id=4d0534ae&"
import script from "./ViewSupplierModelList.vue?vue&type=script&lang=js&"
export * from "./ViewSupplierModelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports